import { InvestmentStrategy, PlanType, RiaPlan } from 'types/plan';
import { apiRequest } from '@utils/request';
import { investmentEntityRequest } from '@utils/request';
import { RiaFeeWaiverOriginType } from 'types/layout/lead';
import { RiaUpgradePreference } from 'types/ria';
import { ServiceLevelName } from 'types/service-level';

export async function getAnnualizedYield(planId: string): Promise<string> {
	const response = await apiRequest.get(`/ria-plan/${planId}/current-yield`);
	const currentYield = response.data;
	return currentYield;
}

export async function getFeeWaiverOriginTypeEnumByName(feeWaiver: string): Promise<RiaFeeWaiverOriginType> {
	const response = await apiRequest.get(`/ria/fee-waiver/${feeWaiver}`);
	const riaFeeWaiverOriginType = response.data;
	return riaFeeWaiverOriginType;
}

export async function getRiaPlanByStrategyAndType(
	investmentStrategy: InvestmentStrategy,
	planType: PlanType
): Promise<RiaPlan> {
	const response = await apiRequest.get(`/ria/investment-strategy/${investmentStrategy}/plan-type/${planType}`);
	return response.data;
}

export async function getRiaPlanById(planId: string): Promise<RiaPlan> {
	const response = await apiRequest.get(`/ria-plan/${planId}`);
	return response.data;
}

export async function getRiaPlansByServiceLevel(
	serviceLevelName: ServiceLevelName,
	iraPlans = false
): Promise<Array<RiaPlan>> {
	const params = iraPlans ? { params: { ira: true } } : {};
	const response = await apiRequest.get(`/service-level/${serviceLevelName}/ria-plans`, params);
	const plans = response.data;
	return plans;
}

export const completeUpgrade = async (riaUpgradePreference: RiaUpgradePreference): Promise<void> => {
	await investmentEntityRequest.post(`/ria/upgrade`, riaUpgradePreference);
};
